import React from "react";

import {
  PencilSquareIcon,
  TrashIcon,
  InfoIcon,
  WarningIcon,
} from "components/Icons";

import { classNames } from "tools/ui";

const ICONS = {
  edit: [PencilSquareIcon, "text-sky-400 active:text-cyan-700"],
  open: [PencilSquareIcon, "text-cyan-500 active:text-cyan-700"],
  delete: [TrashIcon, "text-rose-400 active:text-rose-500"],
  info: [InfoIcon, "text-gray-700 active:text-gray-700"],
  warning: [WarningIcon, "text-amber-600 text-amber-800"],
};

function IconTable({ name, record, onClickButton }) {
  function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    onClickButton(e, name, record);
  }

  const [Icon, color] = ICONS[name] || ICONS["info"];
  return (
    <div className="flex my-auto">
      <button className="mx-auto active:scale-90" key={name} onClick={onClick}>
        <Icon
          className={classNames("h-6 w-6 fill-current", color)}
          aria-hidden="true"
        />
      </button>
    </div>
  );
}

export default IconTable;
